import { useStore } from 'stook'

interface IPickupAddress {
  drivingPickupAddress: string,
  drivingPickupAddressLat: string,
  drivingPickupAddressLng: string,
  drivingPickupCityCode: string,
  drivingPickupCityName: string
}

const INIT_PICKUP_ADDRESS = {
  drivingPickupAddress: '',
  drivingPickupAddressLat: '',
  drivingPickupAddressLng: '',
  drivingPickupCityCode: '',
  drivingPickupCityName: ''
}
export default function usePickupAddress() {
  const [pickupAddress, setPickupAddress] = useStore<IPickupAddress>('PickupAddress', INIT_PICKUP_ADDRESS)

  const resetPickupAddress = () => {
    setPickupAddress(INIT_PICKUP_ADDRESS);
  };

  return {
    pickupAddress,
    setPickupAddress,
    resetPickupAddress,
  }
}